import * as React from 'react';
var context = React.createContext(false);
export var EditModeContextProvider = context.Provider;
export var EditModeContextConsumer = context.Consumer;
export var EditModeContext = context;
//# sourceMappingURL=edit.js.map